import { css as _css } from "@emotion/core";
import React from 'react';
import PropTypes from 'prop-types';
import { Global } from '@emotion/react';
import { ChevronUpIcon, ChevronDownIcon } from '@domain-group/fe-co-icon';
import { SlideDown } from 'react-slidedown';
import * as styles from './allhomes-mobile-expander.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class AllhomesMobileExpander extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: this.props.isExpanded
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.props.onToggle(!this.state.isExpanded);
    this.setState(prev => ({
      isExpanded: !prev.isExpanded
    }));
  }
  render() {
    var isNormalStyle = this.props.expanderStyle === 'normal';
    var isButtonStyle = this.props.expanderStyle === 'button';
    var defaultButton = isNormalStyle ? ___EmotionJSX("button", {
      type: "button",
      css: styles.nameContainer,
      onClick: this.toggle
    }, ___EmotionJSX("div", {
      css: styles.nameLabel(this.props.expanderStyle === 'button')
    }, this.props.name), ___EmotionJSX("div", {
      css: styles.nameIcon
    }, this.state.isExpanded ? ___EmotionJSX(ChevronUpIcon, {
      css: styles.arrowIcon,
      size: "custom"
    }) : ___EmotionJSX(ChevronDownIcon, {
      css: styles.arrowIcon,
      size: "custom"
    }))) : false;
    var buttonStyleButton = isButtonStyle ? ___EmotionJSX("button", {
      type: "button",
      css: styles.nameContainer,
      onClick: this.toggle
    }, ___EmotionJSX("div", {
      css: styles.nameLabel(true)
    }, this.state.isExpanded ? this.props.openButtonText : this.props.name)) : false;
    return ___EmotionJSX("div", {
      css: styles.container
    }, ___EmotionJSX(Global, {
      styles: styles.global
    }), defaultButton, ___EmotionJSX(SlideDown, {
      closed: !this.state.isExpanded,
      css: /*#__PURE__*/_css([styles.sliderBody, styles.sliderContent])
    }, this.state.isExpanded ? this.props.children : null), isNormalStyle && ___EmotionJSX(SlideDown, {
      closed: this.state.isExpanded,
      css: /*#__PURE__*/_css([styles.summary, styles.sliderBody]),
      transitionOnAppear: false
    }, this.state.isExpanded ? null : this.props.summary), buttonStyleButton);
  }
}
AllhomesMobileExpander.propTypes = {
  name: PropTypes.string.isRequired,
  isExpanded: PropTypes.bool,
  onToggle: PropTypes.func,
  summary: PropTypes.node,
  children: PropTypes.node,
  expanderStyle: PropTypes.oneOf(['normal', 'button']),
  openButtonText: PropTypes.string
};
AllhomesMobileExpander.defaultProps = {
  isExpanded: false,
  onToggle: () => {},
  summary: null,
  children: null,
  expanderStyle: 'normal',
  openButtonText: 'Close'
};
export default AllhomesMobileExpander;